import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { DemoLayout } from '@/components/DemoLayout';
import { clearEnrollment } from '@/lib/enrollment';

export function HomePage() {
  const navigate = useNavigate();

  const startEnrollment = () => {
    // Cada "Cadastrar" começa um cadastro novo.
    clearEnrollment();
    navigate('/cadastrar');
  };

  return (
    <DemoLayout>
      <Box sx={{ pt: 4, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant="h1">Reconhecimento facial Identila</Typography>
        <Typography color="text.secondary">
          Cadastre um rosto com prova de vida e, em seguida, reconheça a pessoa só pela
          câmera. Os registros desta demonstração ficam separados dos eventos reais.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 'auto', pb: 2 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<PersonAddAlt1Icon />}
          onClick={startEnrollment}
          data-testid="home-enroll"
        >
          Cadastrar
        </Button>
        <Button
          variant="outlined"
          size="large"
          startIcon={<FaceRetouchingNaturalIcon />}
          onClick={() => navigate('/reconhecer')}
          data-testid="home-recognize"
        >
          Reconhecer
        </Button>
      </Box>
    </DemoLayout>
  );
}
